if (!customElements.get('card-product')) {
  customElements.define(
    'card-product',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.variantInputs = this.querySelectorAll('[type="radio"]');
        this.media = this.querySelector('.media');
        this.link = this.querySelector('.card__information a');
        if (this.variantSelects !== null) {
          for (let i = 0; i < this.variantInputs.length; i++) {
            this.variantInputs[0].classList.add('checked');
          }
          this.variantSelects.addEventListener('change', this.variantChange.bind(this));
        }
      }

      variantChange(evt) {
        evt.preventDefault();
        this.changeImage();
        this.changeLink();
        this.changeButtonVariant();
        this.checkInput();
      }

      changeImage() {
        this.mediaImage = this.media.querySelectorAll('img');
        const offset = 2;
        for (let i = offset; i < this.mediaImage.length; i++) {
          if (this.mediaImage[i].dataset.variant == this.variantSelects.currentVariant.id) {
            this.mediaImage[0].src = this.mediaImage[i].src;
            this.mediaImage[0].srcset = this.mediaImage[i].srcset;
          }
        }
      }
      changeLink() {
        this.link.href = `${this.variantSelects.dataset.url}?variant=${this.variantSelects.currentVariant.id}`;
      }
      changeButtonVariant() {
        this.currentVariant.value = this.variantSelects.currentVariant.id;
      }
      checkInput() {
        for (let i = 0; i < this.variantInputs.length; i++) {
          this.variantInputs[i].classList.remove('checked');
          if (this.variantInputs[i].value === this.variantSelects.options[0]) {
            this.variantInputs[i].classList.add('checked');
          }
        }
      }
    }
  );
}
